module.exports = __webpack_public_path__ + "static/media/Vector.a6d3c5be.png";